export default {
    domain: process.env.NODE_ENV === 'production' ? '' : ''
}